<div class="w-full">
    <div class="flex justify-between border-b border-b-gray-300 zuper-dialog-header">
      <h6 mat-dialog-title class="font-semibold primary-font">{{'text.save_filter' | translate}}</h6>
      <!-- Dismiss button -->
      <div class="flex items-center ml-auto">
        <span (click)="closeDialogOnCancel();"
            class="rounded-full flex justify-center items-center hover:bg-gray-200 h-9 w-9 p-2 cursor-pointer">
            <em class="ti ti-x text-xl font-bold"></em>
        </span>
      </div>
    </div>
    <div class="flex flex-col">
      <form #saveFilterForm="ngForm" (ngSubmit)="closeDialog(saveFilterForm);" ngNativeValidate>
        <div class="zuper-dialog-body">
          <div class="flex justify-around space-x-2">
              <div class="w-full mr-1">
                  <mat-form-field class="example-full-width" appearance="fill" ngClass="w-full" [hideRequiredMarker]="true" [floatLabel]="'always'">
                      <mat-label class="required text-base font-medium">{{'text.filter_name' | translate}}</mat-label>
                      <input type="text" id="filter_name" name="filter_name" class="form-control" #filter_name="ngModel" matInput [(ngModel)]="filter.filter_name" placeholder="{{'text.filter_name' | translate}}" required>
                      <mat-error *ngIf="(filter_name.touched || saveFilterForm.submitted) && filter_name.errors?.required" class="primary-font text-base">
                        {{'text.filter_name_required' | translate}}
                      </mat-error>
                  </mat-form-field>
              </div>
              <div class="w-full ml-1">
                  <mat-form-field appearance="fill" ngClass="w-full mat-form-field-should-float" [hideRequiredMarker]="true" [floatLabel]="'always'">
                    <mat-label class="required text-base font-medium">{{'text.filter_applicability' | translate}}</mat-label>
                    <mat-select id="applicability" name="applicability" class="form-control" #applicability="ngModel" [(ngModel)]="filter.filter_applicability" placeholder="{{'text.select_applicability' | translate}}" (selectionChange)="onSelectionChange($event)" required>
                      <mat-option *ngFor="let applicability of applicabilities" [value]="applicability.value">
                        {{applicability.key | translate}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="(applicability.touched || saveFilterForm.submitted) && applicability.errors?.required" class="primary-font text-base">
                      {{'text.filter_name_required' | translate}}
                    </mat-error>
                  </mat-form-field>
              </div>
          </div>
          <div class="w-full ml-1 mt-2" *ngIf="['USERS','TEAMS'].includes(filter.filter_applicability)">
            <mat-label class="required text-base font-medium">{{getFieldValueLabel | translate}}</mat-label>
            <ng-select [id]="filter.applicability" ngClass="w-full" appearance="fill" [items]="listValue$ | async"
                    required 
                    id="field_value" 
                    name="field_value" 
                    class="form-control mt-2"
                    #field_value="ngModel"
                    bindLabel="displayValue"
                    bindValue="{{getLookupValueKey()}}"
                    placeholder="{{fieldValuePlaceholder | translate}}"
                    appendTo="body"
                    [multiple]="true"
                    [hideSelected]="true"
                    [loading]="lookupLoading"
                    typeToSearchText="{{'info.type_to_search_text' | translate}}"
                    [(ngModel)]="filter.value"
                    [typeahead]="valueSubject$"
                    (scrollToEnd)="appendValueToItems()"
                    >
                    <ng-template *ngIf="filter.filter_applicability !== 'USERS'" ng-label-tmp let-item="item" let-clear="clear">
                      <span class="ng-value-label">{{item['displayValue'] || ''}}</span>
                      <span class="ng-value-icon right" (click)="clear(item)">×</span>
                    </ng-template>
                    <ng-template *ngIf="filter.filter_applicability === 'USERS'" ng-label-tmp let-item="item" let-clear="clear">
                      <span class="ng-value-label">{{item.first_name || ''}} {{item.last_name || ''}} - {{item.email || ''}}</span>
                      <span class="ng-value-icon right" (click)="clear(item)">×</span>
                    </ng-template>
                    <ng-template *ngIf="filter.filter_applicability === 'USERS'" ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                      <span >{{item.first_name + ' ' + item.last_name}}</span>
                      <br>
                      <span class="text-md text-secondary">{{ item.email}}</span>
                    </ng-template>
            </ng-select>
            <mat-error *ngIf="(field_value.touched || saveFilterForm.submitted) && field_value.errors?.required" class="primary-font text-base mt-1">
              {{fieldValueErrorMessage | translate}}
            </mat-error>
          </div>
        </div>
        <div class="flex justify-end space-x-3 pt-5 border-t border-gray-300 zuper-dialog-footer">
            <button mat-stroked-button class="px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-600 bg-white btn-small hover:bg-gray-50 focus:outline-none" type="button" (click)="closeDialogOnCancel();">{{'cancel.text' | translate}}</button>
            <button class="bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-medium rounded-md text-white-600 btn-small focus:outline-none" [disabled]="saveFilterForm.invalid" type="submit">{{'text.save_filter' | translate}}</button>
        </div>
      </form>
    </div>
</div>